/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { tuple } from '../_util/type';
const LinkTypes = tuple('default', 'primary', 'text');
const SizeTypes = tuple('small', 'medium');
const InternalLink = (props, ref) => {
    const { prefixCls: customizePrefixCls, icon = null, children, type = 'default', size = 'small', disabled = false, className, onClick } = props, rest = __rest(props, ["prefixCls", "icon", "children", "type", "size", "disabled", "className", "onClick"]);
    const linkRef = ref || React.createRef();
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('link', customizePrefixCls);
    const classes = classNames(prefixCls, className, {
        [`${prefixCls}-${type}`]: type,
        [`${prefixCls}-${size}`]: !icon,
        [`${prefixCls}-icon`]: icon,
        [`${prefixCls}-disabled`]: disabled,
    });
    const handleClick = (e) => {
        if (disabled) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
        }
        else {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    };
    return (<a {...rest} ref={linkRef} className={classes} onClick={handleClick}>
            {icon}
            {children}
        </a>);
};
const Link = React.forwardRef(InternalLink);
Link.displayName = 'Link';
export default Link;
